<app-profile-header></app-profile-header>
<section class="body-section Partner-request" *ngIf="!showingSentRequest">
    <div class="container">
        <p-toast key="toastmsg"></p-toast>
        <main>
            <div class="bottom-container matches-table  d-none">
                <div class="box transaction-box ">
                    <div class="not-found-section">
                        <div class="col-md-12 not-found-body  "><img src="assets/img/logo/not-found.gif" alt="">
                            <h4>Coming Soon!</h4>
                            <p>Exciting developments are on the horizon! Keep an eye out for an impending
                                announcement that will have you excited and anticipating what's to come. We can't
                                wait to tell you about this fantastic news. Keep a look out for additional updates,
                                because something fantastic is on the way!</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-container ">
                <div class="box transaction-box ">
                    <div class="header-container">
                        <h3 class="section-header">Partner Request</h3>
                        <!-- <div class="p-field p-col-1" *ngIf="!showingSentRequest">
                            <button pButton pRipple label="Sent Request" (click)="openmodal() "
                                class="p-button p-mr-2 p-mb-2"></button>

                        </div> -->
                    </div>

                    <!-- <div style="padding: .5em 0 1em 0">
                        <p-button (click)="openmodal()  " styleClass="p-button-text" label="Current Request"></p-button>
                        <p-button (click)="onCloseModal() " styleClass="p-button-text" label="Sent Request" ></p-button>
                       
                    </div> -->

                    <p-tabView [(activeIndex)]="activeIndex" (onChange)="clearFilter()">
                        <p-tabPanel header="Current Request">

                            <div class="card date-filter-div">
                                <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-2">
                                        <label for="searchfield">Select Field</label>
                                        <p-dropdown [options]="searchBy" [(ngModel)]="searchby"
                                            placeholder="Select Field" optionLabel="label"></p-dropdown>
                                    </div>
                                    <div class="p-field p-col-2">
                                        <label for="startdt">Start Date</label>
                                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                            [(ngModel)]="startDate" class="p-calendar" inputId="calendar"
                                            dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                                    </div>
                                    <div class="p-field p-col-2">
                                        <label for="enddt">End Date</label>
                                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                            [(ngModel)]="endDate" class="p-calendar" inputId="calendar"
                                            dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                                    </div>
                                    <div class="p-field p-col" style="padding-top: 28px;">
                                        <div class="button-div">
                                            <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-2"
                                                (click)="loaduserList($event)"></button>
                                        </div>

                                    </div>
                                    <div class="p-field p-col-2" style="padding-top: 28px;">
                                        <div class="clear-button-div">
                                            <button pButton label="Clear Filters"
                                                class="p-button-outlined p-mr-0 p-mb-0" icon="pi pi-filter-slash"
                                                pTooltip="Clear Filters" tooltipPosition="bottom"
                                                (click)="clear()"></button>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div class="tab-content" id="pills-tabContent">
                                <div class="mobile-filter">
                                    <div class="col-md-12 right-section-top-bar px-4">
                                        <div data-bs-toggle="modal" data-bs-target="#mobile-filter-popup"
                                            class="mobile-fliter-icon"><i class="bx bx-filter-alt"></i> Filters </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                                    aria-labelledby="pills-home-tab">
                                    <p-table id="vdtnetable10" #dt [value]="userList" [paginator]="true" [rows]="10"
                                        [rowsPerPageOptions]="paginationOption" [lazy]="true" scrollHeight="auto" pageLinks="3" [showPageLinks]="true"
                                        scrollDirection="horizontal" [totalRecords]="totalRecords" [loading]="loading"
                                        [scrollable]="true" cellpadding="0" class="transaction-history"
                                        (onLazyLoad)="loaduserList($event)" aria-describedby="vdtnetable10_info">
                                        <ng-template pTemplate="header">
                                            <tr>

                                                <th class=" name-td-partner rin-dt-align-left sorting_disabled rin-dt-ellpsis-overflow-1"
                                                    rowspan="1" colspan="1"
                                                    style="color: black;background-color: white;">
                                                    <div>Name
                                                        <!-- <p-sortIcon field="userName"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1" colspan="1">
                                                    <div>TPL Rating
                                                        <!-- <p-sortIcon field="Tpl_rating"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1" colspan="1">
                                                    <div>Amount
                                                        <!-- <p-sortIcon field="charges"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled current-request-location-td" rowspan="1"
                                                    colspan="1">
                                                    <div>Location
                                                        <!-- <p-sortIcon field="venue"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1" colspan="1">
                                                    <div>Date
                                                        <!-- <p-sortIcon field="startDate"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1" colspan="1">
                                                    <div>Time
                                                        <!-- <p-sortIcon field="startDate"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1" colspan="1">
                                                    <div>Status
                                                        <!-- <p-sortIcon field="bookingStatus"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1" colspan="1"
                                                    style="        min-width: 230px;">
                                                    <div>Action

                                                    </div>
                                                </th>

                                            </tr>
                                        </ng-template>

                                        <ng-template pTemplate="body" let-user>
                                            <tr>
                                                <td
                                                    class=" name-td-partner  rin-dt-ellpsis-overflow-1 rin-dt-align-left">
                                                    <!-- <a
                                    href="/en/tournament/22509/u8l-open-singles-amateurs-championship"
                                    data-action-click="go-to-event"
                                    class="rin-dt-table-action"> -->
                                                    <div class="data">
                                                        <span class="mobileversion-lable">Name:</span>
                                                        {{user.opponentUserName}}
                                                    </div>
                                                    <!-- </a> -->
                                                    <br> <!---->
                                                </td>
                                                <td class="rating-td-partner"><span
                                                        class="rin-type-label state-finished">
                                                        <span class="mobileversion-lable">TPL Rating:</span>
                                                        {{user.rating}}
                                                    </span></td>
                                                <td><span class="rin-type-label state-finished">
                                                        <span class="mobileversion-lable">Amount:</span>
                                                        ₹ {{user.charges}}
                                                    </span></td>
                                                <td class="current-request-location-td"><span
                                                        class="rin-type-label state-finished">
                                                        <span class="mobileversion-lable">Location:</span>
                                                        {{user.venue}}
                                                    </span></td>
                                                <td><span class="rin-type-label state-finished">
                                                        <span class="mobileversion-lable">Date:</span> {{user.startDate
                                                        | date : 'dd-MM-yyyy'}}
                                                    </span></td>
                                                <td><span class="rin-type-label state-finished">
                                                        <span class="mobileversion-lable">Time:</span> {{user.startDate
                                                        | date : 'h:mm a'}}
                                                    </span></td>
                                                <td class="mobile-status  {{user.bookingStatus}}"><span
                                                        class="rin-type-label state-finished">
                                                        <span class="mobileversion-lable">Status:</span>
                                                        {{user.bookingStatus}}
                                                    </span></td>
                                                <td class="buttons-action-div">
                                                    <div class="status-buttons" *ngIf="user.bookingStatus=='Booked'">
                                                        <button class="btn btn-success"
                                                            (click)="approveuser(user)">Approve</button>
                                                        <button class="btn btn-danger" (click)="rejectuser(user)">
                                                            Reject</button>

                                                    </div>
                                                    <div class="status-buttons" *ngIf="user.bookingStatus!='Booked'">
                                                        <button class="btn btn-success" disabled="true"
                                                            (click)="approveuser(user)">Approve</button>
                                                        <button class="btn btn-danger" (click)="rejectuser(user)"
                                                            disabled="true">
                                                            Reject</button>

                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="7">
                                                    <div class="not-found-section">
                                                        <div class="col-md-12 not-found-body">
                                                            <img src="assets/img/logo/not-found.gif" alt="">
                                                            <h4>Sorry! No Request Found </h4>


                                                        </div>

                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="summary">
                                            <div class="p-d-flex p-ai-center p-jc-between">
                                                {{totalRecords }} Partner Requests
                                            </div>
                                        </ng-template>
                                    </p-table>
                                </div>
                                <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
                            </div>

                        </p-tabPanel>
                        <p-tabPanel header="Sent Request">
                            <div class="card  date-filter-div">
                                <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-2">
                                        <label for="searchfield">Select Field</label>
                                        <p-dropdown [options]="searchByStatus" [(ngModel)]="searchbyOpponent"
                                            placeholder="Select Field" optionLabel="label"></p-dropdown>
                                    </div>
                                    <div class="p-field p-col-2">
                                        <label for="startdt">Start Date</label>
                                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                            [(ngModel)]="startDateOpponent" class="p-calendar" inputId="calendar"
                                            dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                                    </div>
                                    <div class="p-field p-col-2">
                                        <label for="enddt">End Date</label>
                                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                            [(ngModel)]="endDateOpponent" class="p-calendar" inputId="calendar"
                                            dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                                    </div>
                                    <div class="p-field p-col" style="padding-top: 28px;">
                                        <div class="button-div">
                                            <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-2"
                                                (click)="loaduserSentRequestList($event)"></button>
                                        </div>

                                    </div>
                                    <div class="p-field p-col-2" style="padding-top: 28px;">
                                        <div class="clear-button-div">
                                            <button pButton label="Clear Filters"
                                                class="p-button-outlined p-mr-0 p-mb-0" icon="pi pi-filter-slash"
                                                pTooltip="Clear Filters" tooltipPosition="bottom"
                                                (click)="clear2()"></button>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div class="tab-content" id="pills-tabContent">
                                <div class="mobile-filter">
                                    <div class="col-md-12 right-section-top-bar px-4">
                                        <div data-bs-toggle="modal" data-bs-target="#mobile-filter-popup2"
                                            class="mobile-fliter-icon"><i class="bx bx-filter-alt"></i> Filters </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                                    aria-labelledby="pills-home-tab">
                                    <p-table id="vdtnetable10" #dt [value]="opponentUserList" [paginator]="true"
                                        [rows]="10" [rowsPerPageOptions]="paginationOption" [lazy]="true"
                                        scrollHeight="auto" scrollDirection="horizontal" pageLinks="3" [showPageLinks]="true"
                                        [totalRecords]="totalOpponentRecords" [loading]="loading" [scrollable]="true"
                                        cellpadding="0" class="transaction-history"
                                        (onLazyLoad)="loaduserSentRequestList($event)"
                                        aria-describedby="vdtnetable10_info">
                                        <ng-template pTemplate="header">
                                            <tr>

                                                <th class=" name-td-partner rin-dt-align-left sorting_disabled rin-dt-ellpsis-overflow-1"
                                                    rowspan="1" colspan="1"
                                                    style="color: black;background-color: white;">
                                                    <div>Name
                                                        <!-- <p-sortIcon field="userName"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class=" ranking-td-partner sorting_disabled tpl-rating-td"
                                                    rowspan="1" colspan="1">
                                                    <div>TPL Rating
                                                        <!-- <p-sortIcon field="Tpl_rating"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1" colspan="1">
                                                    <div>Amount
                                                        <!-- <p-sortIcon field="charges"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1"
                                                    class="sent-request-location-td" colspan="1">
                                                    <div>Location
                                                        <!-- <p-sortIcon field="venue"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled  sent-request-date-td" rowspan="1"
                                                    colspan="1">
                                                    <div>Date
                                                        <!-- <p-sortIcon field="startDate"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled sent-request-time-td" rowspan="1"
                                                    colspan="1">
                                                    <div>Time
                                                        <!-- <p-sortIcon field="startDate"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled sent-request-status-td" rowspan="1"
                                                    colspan="1">
                                                    <div>Status
                                                        <!-- <p-sortIcon field="bookingStatus"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <th class="" rowspan="1"
                                                    colspan="1">
                                                     <div>Action
                                                        <!-- <p-sortIcon field="bookingStatus"></p-sortIcon> -->
                                                    </div>
                                                </th>
                                                <!-- <th class="sorting_disabled" rowspan="1" colspan="1"
                                style="        min-width: 230px;">
                                <div>Action

                                </div>
                            </th> -->

                                            </tr>
                                        </ng-template>

                                        <ng-template pTemplate="body" let-opponentuser>
                                            <tr>
                                                <td
                                                    class=" name-td-partner rin-dt-ellpsis-overflow-1 rin-dt-align-left">
                                                    <div class="data">
                                                        <span class="mobileversion-lable">Name:</span>
                                                        {{opponentuser.userName}}
                                                    </div>

                                                    <!-- <a
                                    href="/en/tournament/22509/u8l-open-singles-amateurs-championship"
                                    data-action-click="go-to-event"
                                    class="rin-dt-table-action"> -->

                                                    <!-- </a>  -->
                                                    <br> <!---->
                                                </td>
                                                <td class="tpl-rating-td"><span
                                                        class="ranking-td-partner rin-type-label state-finished">
                                                        <span class="mobileversion-lable">TPL Rating:</span>
                                                        {{opponentuser.rating}}
                                                    </span></td>
                                                <td><span class="rin-type-label state-finished">
                                                        <span class="mobileversion-lable">Amount:</span>
                                                        ₹ {{opponentuser.charges}}
                                                    </span></td>
                                                <td class="sent-request-location-td"><span
                                                        class="rin-type-label state-finished">
                                                        <span class="mobileversion-lable">Location:</span>
                                                        {{opponentuser.venue}}
                                                    </span></td>
                                                <td class="sent-request-date-td"><span
                                                        class="rin-type-label state-finished">
                                                        <span class="mobileversion-lable">Date:</span>
                                                        {{opponentuser.startDate
                                                        | date : 'dd-MM-yyyy'}}
                                                    </span></td>
                                                <td class="sent-request-time-td"><span
                                                        class="rin-type-label state-finished ">
                                                        <span class="mobileversion-lable">Time:</span>
                                                        {{opponentuser.startDate
                                                        | date : 'h:mm a'}}
                                                    </span></td>
                                                <td *ngIf="opponentuser.bookingStatus=='Booked'"
                                                    class=" mobile-status pending-status">
                                                    <div class="data"> <span class="mobileversion-lable">Status:</span>
                                                        <span class="rin-type-label state-finished pendding-status"
                                                            style="color: #F59E0B;">
                                                             Pending
                                                        </span>
                                                    </div>
                                                </td>
                                                <td *ngIf="opponentuser.bookingStatus!='Booked'"
                                                    class="  {{opponentuser.bookingStatus}} mobile-status sent-request-status-td">
                                                    <div class="data">
                                                        <span class="mobileversion-lable">Status:</span>
                                                        <span
                                                            class="rin-type-label state-finished  {{opponentuser.bookingStatus}}">
                                                           
                                                            {{opponentuser.bookingStatus}}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td > 
                                                    <p-button *ngIf="opponentuser.bookingStatus=='Booked'" styleClass="p-button-danger" (click)="cancelBooking(opponentuser)">Cancel Request</p-button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="7">
                                                    <div class="not-found-section">
                                                        <div class="col-md-12 not-found-body">
                                                            <img src="assets/img/logo/not-found.gif" alt="">
                                                            <h4>Sorry! No Request Found </h4>


                                                        </div>

                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="summary">
                                            <div class="p-d-flex p-ai-center p-jc-between">
                                                {{totalOpponentRecords }} Partner Requests
                                            </div>
                                        </ng-template>
                                    </p-table>
                                </div>
                                <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
                            </div>
                        </p-tabPanel>
                    </p-tabView>
                </div>
            </div>
        </main>




    </div>
</section>

<div class="modal fade" id="mobile-filter-popup2" tabindex="-1" aria-labelledby="mobile-filter-popupLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <div class="col-md-12 main-title">
                    <h4> <span><i class='bx bx-filter-alt'></i></span> Filters</h4>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body mobilefilter">
                <div class="col-md-3 p-0">
                    <div class="card date-filter-div">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-2">
                                <label for="searchfield">Select Field</label>
                                <p-dropdown [options]="searchBy" [(ngModel)]="searchbyOpponent"
                                    placeholder="Select Field" optionLabel="label"></p-dropdown>
                            </div>
                            <div class="p-field p-col-2">
                                <label for="startdt">Start Date</label>
                                <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                    [(ngModel)]="startDateOpponent" class="p-calendar" inputId="calendar"
                                    dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                            </div>
                            <div class="p-field p-col-2">
                                <label for="enddt">End Date</label>
                                <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                    [(ngModel)]="endDateOpponent" class="p-calendar" inputId="calendar"
                                    dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                            </div>


                        </div>
                    </div>
                </div>
                <div class="col-md-12  p-p-0 left-side-bar-filter " style="display: block!important;">
                    <div class="left-side-section" style="box-shadow: none!important;"></div>
                </div>
            </div>
            <div class="modal-footer filter-button">

                <button pButton label="Clear Filters" class="p-button-outlined p-mr-0 p-mb-0" pTooltip="Clear Filters"
                    tooltipPosition="bottom" (click)="clear2()"></button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close"
                    (click)="loaduserSentRequestList($event)">Apply</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="mobile-filter-popup" tabindex="-1" aria-labelledby="mobile-filter-popupLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <div class="col-md-12 main-title">
                    <h4> <span><i class='bx bx-filter-alt'></i></span> Filters</h4>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body mobilefilter">
                <div class="col-md-3 p-0">
                    <div class="card date-filter-div">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-2">
                                <label for="searchfield">Select Field</label>
                                <p-dropdown [options]="searchBy" [(ngModel)]="searchby" placeholder="Select Field"
                                    optionLabel="label"></p-dropdown>
                            </div>
                            <div class="p-field p-col-2">
                                <label for="startdt">Start Date</label>
                                <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                    [(ngModel)]="startDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                                    [showIcon]="true"></p-calendar>
                            </div>
                            <div class="p-field p-col-2">
                                <label for="enddt">End Date</label>
                                <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                    [(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                                    [showIcon]="true"></p-calendar>
                            </div>


                        </div>
                    </div>
                </div>
                <div class="col-md-12  p-p-0 left-side-bar-filter " style="display: block!important;">
                    <div class="left-side-section" style="box-shadow: none!important;"></div>
                </div>
            </div>
            <div class="modal-footer filter-button">

                <button pButton label="Clear Filters" class="p-button-outlined p-mr-0 p-mb-0" pTooltip="Clear Filters"
                    tooltipPosition="bottom" (click)="clear()"></button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close"
                    (click)="loaduserList($event)">Apply</button>
            </div>
        </div>
    </div>
</div>